export default __webpack_public_path__ + "static/media/Dynamicbehaviour.f32b4ebb.webp";